import { useQuery } from "@apollo/client/react";
import { PublicProductsDocument } from "@/generated/graphql";
import type { PublicProduct } from "@/types/models";

export interface PublicProductsFilters {
  categorySlug?: string;
  search?: string;
}

export function usePublicProducts(
  storeSlug: string | undefined,
  filters: PublicProductsFilters = {}
) {
  const { categorySlug, search } = filters;
  const trimmedSearch = search?.trim() || undefined;

  const { data, previousData, loading, error, refetch } = useQuery(PublicProductsDocument, {
    variables: {
      storeSlug: storeSlug!,
      categorySlug: categorySlug || null,
      search: trimmedSearch || null,
    },
    fetchPolicy: "cache-and-network",
    skip: !storeSlug,
  });

  const products: PublicProduct[] =
    data?.publicProducts ?? previousData?.publicProducts ?? [];
  const isInitialLoading = loading && products.length === 0;

  return {
    products,
    loading,
    isInitialLoading,
    error,
    refetch,
  };
}
